import { Component, OnInit } from '@angular/core';
import {Slider} from '../../models/slider';
import {Router} from '@angular/router';
import {SliderService} from '../../services/slider.service';
import {BaseService} from '../../base.service';
import { ContractsService } from '../../services/contracts.service';
import { ContractListItem } from '../../models/contractListItem';
import { ContractListItemSource } from '../../models/contractListItemSource';
import { TenantService } from '../../services/tenant.service';
import { Tenant } from '../../models/tenant';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: []
})
export class TenantListComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;
  private tenants:Tenant[] = [];
  private sliderId: number;
  
  total = 10000000;
  bigCurrentPage: number = 1;
  maxSize: number = 5;
  size: number = 10;
  page: number = 1;
  status: string = '';

  filter_dni: string = '';
  filter_email: string = '';
  filter_lastName: string = '';
  filter_name: string = '';
  filter_status: boolean = true;

  constructor(
    private router: Router,
    private service: TenantService,
    private baseService: BaseService
  ) {}

  ngOnInit() {
    this.titleComponent = 'Inquilinos';
    this.titlePanel = 'Lista de Inquilinos';
    this.baseService.changedComponentName(this.titleComponent);

    this.list( 0 , this.filter_dni , this.filter_email , this.filter_lastName , this.filter_name , this.filter_status );
  }
  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	  	1
  list( page:number = 0 , dni:string = "" , email:string = "" , lastName:string = "" , name:string="", status:boolean = true ) {
    this.service.getAll( page , dni , email , lastName , name, status , this.size ).subscribe(d => {
      console.log(d);
      
      if (d) {
        
        let data:any = d;
        this.tenants = data.content;
        
        this.total = data.totalElements;
        this.page = data.number;
        
      }
      
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/tenants', id];
    this.router.navigate(link);
  }


  pageChanged(event: any): void {
    console.log(event.page);
    this.list( event.page -1  , this.filter_dni , this.filter_email , this.filter_lastName  ,this.filter_name , this.filter_status );
  }

  filtrar(){
    this.list( 0 , this.filter_dni , this.filter_email , this.filter_lastName  ,this.filter_name, this.filter_status );
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/tenant/tenant-list.component.ts